import { createLogic } from "redux-logic";
import {
    type UscExtPriceCalculate,
    type UscExtPriceSetLocation,
    setExternalPriceData,
    setExternalPriceFailed,
    setExternalPriceFetching,
    USC_EXT_PRICE_CALCULATE,
    USC_EXT_PRICE_SET_LOCATION,
} from "../actions/UscExternalPriceActions";
import { replaceQueryParams } from "../../../../common-deprecated/History";
import {
    calculateExternalPrice,
    externalPriceFnIsAvailable,
    getExternalPricePayload,
} from "../../utils/externalPriceUtils";
import { startFinanceFetch } from "../actions/UscFinanceActions";
import { enableUscMonthlyRate } from "../../utils/settings";
import Debug from "../../../../common-deprecated/Debug";
import { getSessionStorageParams, setTaxLocationIdToStorage } from "../../utils/sessionStorage";
import type { UscLogicType } from "../store";

const taxLocationLogic = (createLogic as UscLogicType<UscExtPriceSetLocation>)({
    type: USC_EXT_PRICE_SET_LOCATION,

    process({ action, getState }, _, done) {
        const { commonSettings, vehicle } = getState();
        const sessionStorageParams = getSessionStorageParams({ commonSettings, vehicle });

        setTaxLocationIdToStorage(sessionStorageParams, action.locationId || "");

        replaceQueryParams({ taxLocationId: action.locationId });
        done();
    },
});

const calculatePriceLogic = (createLogic as UscLogicType<UscExtPriceCalculate>)({
    type: USC_EXT_PRICE_CALCULATE,

    async process({ getState }, dispatch, done) {
        const state = getState();
        const { commonSettings, uscSettings, vehicle, dealer, externalPrice, carDelivery, accessories } = state;

        if (externalPriceFnIsAvailable()) {
            const externalPricePayload = getExternalPricePayload(
                vehicle.type,
                vehicle.result!,
                dealer.dealer,
                externalPrice.userTaxLocationId,
                accessories.accessoryResults,
                accessories.packResults,
                carDelivery.deliveryConfig,
                commonSettings.brand,
            );
            const data = calculateExternalPrice(externalPricePayload);

            dispatch(setExternalPriceFetching(false));
            if (!data) {
                // Fetch failed, set the failed state.
                dispatch(setExternalPriceFailed(true, externalPricePayload));
                // Set external price to null and propagate the payload to the store for easier debugging.
                dispatch(setExternalPriceData(null, externalPricePayload));
            } else if (data) {
                dispatch(setExternalPriceData(data, externalPricePayload));
                // Reload finance info if enabled.
                if (enableUscMonthlyRate(commonSettings, uscSettings, vehicle.result, vehicle.type))
                    dispatch(startFinanceFetch());
            }
        } else {
            // If this happens either the initializeExternalPriceFn has failed or has not completed yet.
            // This should realistically not happen except if something breaks TMEF side or we are dispatching the USC_EXT_PRICE_CALCULATE action too early.
            Debug.error("External price logic triggered but function is not available.");
        }

        done();
    },
});

export default [taxLocationLogic, calculatePriceLogic];
